module.exports = ".expired {\n  color: red; }\n"